import React, { useEffect, useState } from 'react'
import Footer from '../../../Components/Footer'
import Header from '../../../Components/Header'
import { BrowserView, MobileView } from 'react-device-detect'
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { ApiService } from '../../../Components/Services/apiServices'
import AccountSidebar from '../AccountSidebar'

const MyBooking = () => {


    const [user, setUser] = useState(null);
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const userData = localStorage.getItem("USER_DATA");
        if (userData) {
            const user = JSON.parse(userData);
            setUser(user);

            fetchBookings(user.id);
        }
    }, []);




    const fetchBookings = async (userId) => {
        setLoading(true);
        try {
            const response = await ApiService.Commanfetchrequest(`getbookings/${userId}`);
            setBookings(response.bookings);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('Error fetching bookings:', error);
        }
    };



    if (loading) {
        return <div>Loading...</div>;
    }

    if (!bookings.length) {
        return (
            <div className="container py-5">
                <h3 className="text-center">No bookings found</h3>
            </div>
        );
    }

    return (
        <>
            <Header />
            <BrowserView>

                <div className="account-container">
                    {/* Sidebar */}
                    <AccountSidebar />

                    {/* Main Content */}
                    <div className="account-content">
                        <Outlet />
                        <div className="container py-5">
                            <h2 className="text-center mb-4">My Bookings</h2>

                            <div className="row">
                                {bookings.map((booking) => (
                                    <div key={booking.booking_id} className="col-12 col-md-6 col-lg-4 mb-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">{booking.room_name}</h5>
                                                <p><strong>Check-in: </strong>{new Date(booking.check_in).toLocaleDateString()}</p>
                                                <p><strong>Check-out: </strong>{new Date(booking.check_out).toLocaleDateString()}</p>
                                                <p><strong>Guests: </strong>{booking.guests}</p>
                                                <p><strong>Total Price: </strong>₹{booking.total_price}</p>
                                                <p><strong>Status: </strong>
                                                    {booking.status === 1 ? (
                                                        <p className='badge bg-success'>Booked</p>
                                                    ) : (
                                                        <p className='badge bg-danger'>Cancelled</p>
                                                    )}
                                                </p>

                                                <div className="d-flex justify-content-between">
                                                    <Link to={`/booking-detail/${booking.booking_id}`} className="btn btn-primary">
                                                        View Details
                                                    </Link>
                                                    {/* <button className='btn btn-danger'>Cancel Booking</button> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

            </BrowserView>

            <MobileView>
                <div className="container py-5">
                    <h2 className="text-center mb-4">My Bookings</h2>

                    <div className="row">
                        {bookings.map((booking) => (
                            <div key={booking.booking_id} className="col-12 col-md-6 col-lg-4 mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">{booking.room_name}</h5>
                                        <p><strong>Check-in: </strong>{new Date(booking.check_in).toLocaleDateString()}</p>
                                        <p><strong>Check-out: </strong>{new Date(booking.check_out).toLocaleDateString()}</p>
                                        <p><strong>Guests: </strong>{booking.guests}</p>
                                        <p><strong>Total Price: </strong>₹{booking.total_price}</p>
                                        <p><strong>Status: </strong>
                                            {booking.status === 1 ? (
                                                <p className='badge bg-success'>Booked</p>
                                            ) : (
                                                <p className='badge bg-danger'>Cancelled</p>
                                            )}
                                        </p>

                                        <div className="d-flex justify-content-between">
                                            <Link to={`/booking-detail/${booking.booking_id}`} className="btn btn-primary">
                                                View Details
                                            </Link>
                                            {/* <button className='btn btn-danger'>Cancel Booking</button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


            </MobileView>



            <Footer />
        </>
    )
}

export default MyBooking;
